
import AppLayoutVue from "@/Layouts/AppLayout.vue";
import { computed, defineComponent, PropType } from "vue";
import Card from "@/Components/General/Card.vue";
import CategorySaleForm from "@/Components/Reports/CategorySaleForm.vue";
import Category from "@/types/Category";
import { BarChart } from "vue-chart-3";
import { Chart, ChartData, BarController, CategoryScale, LinearScale, ArcElement, BarElement, ChartOptions, Tooltip, Title } from "chart.js";
import dayjs from "dayjs";
import StatisticsNav from "@/Components/Reports/StatisticsNav.vue";

Chart.register(BarController, CategoryScale, LinearScale, BarElement, Tooltip, Title);

interface SaleData {
  month: number;
  count: number;
}

export default defineComponent({
  layout: AppLayoutVue,
  props: {
    categories: {
      type: Array as PropType<Category[]>,
      required: true,
    },
    selectedCategories: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
    excludeWeborders: {
      type: Boolean,
      default: () => false,
    },
    data: {
      type: Array as PropType<SaleData[]>,
      required: true,
    },
    dateFrom: {
      type: String,
      required: true,
    },
    dateTo: {
      type: String,
      required: true,
    }
  },
  setup(props) {

    const months = [
      "Januar",
      "Februar",
      "Mars",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];

    const chartData = computed((): ChartData<"bar"> => {
      return {
        labels: months,
        datasets: [
          {
            label: "Antall ordre",
            data: props.data?.map((data) => data.count) ?? [],
            backgroundColor: [
              "#3e9ae6",
              "#3e9ae6",
              "#4dd43b",
              "#4dd43b",
              "#4dd43b",
              "#ffde24",
              "#ffde24",
              "#ffde24",
              "#e07726",
              "#e07726",
              "#e07726",
              "#3e9ae6",
            ],
          }
        ],
      }
    });

    const chartOptions: ChartOptions = {
      animation: {
        duration: 750,
      },
      plugins: {
        title: {
          display: true,
          text: "Ordre per måned",
        }
      },
      scales: {
        y: {
          beginAtZero: true,
        }
      },
      locale: "nb-NO",
      maintainAspectRatio: false,
    }

    return {
      chartData,
      chartOptions,
    };
  },
  components: { Card, CategorySaleForm, BarChart, StatisticsNav }
});
